import { useContext } from 'react'
import { AuthContext, AuthContextType } from './AuthProvider'

export function useAuth(): AuthContextType {
  const context = useContext(AuthContext)

  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider')
  }

  return context
}

export function useIsAuthenticated(): boolean {
  const { isAuthenticated } = useAuth()
  return isAuthenticated
}

export function useUser() {
  const { user } = useAuth()
  return user
}

export function useTenantId(): string {
  const { user } = useAuth()
  return user?.tenantId || 'default-tenant'
}

export function useUserRoles(): string[] {
  const { user } = useAuth()
  return user?.roles || []
}

export function useHasRole(role: string): boolean {
  const roles = useUserRoles()
  return roles.includes(role)
}

export function useHasAnyRole(requiredRoles: string[]): boolean {
  const roles = useUserRoles()
  return requiredRoles.some((role) => roles.includes(role))
}

export function usePortalAccess(): string[] {
  const { user } = useAuth()
  return user?.portalAccess || []
}

export function useHasPortalAccess(portal: 'client' | 'adminclient' | 'admin'): boolean {
  const portalAccess = usePortalAccess()
  return portalAccess.includes(portal)
}

export function useIsCabinetUser(): boolean {
  return useHasPortalAccess('adminclient')
}
